import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { QuestionDto } from '@services/api'
import {
  bulkDeleteQuestions,
  createQuestion,
  deleteQuestion,
  deleteQuestions,
  findAllQuestions,
  findSiteQuestions,
  updateQuestion,
} from '@state/thunks/questionThunk'

type questionState = {
  questions: QuestionDto[]
  siteQuestions: QuestionDto[]
}

const initialState: questionState = {
  questions: [],
  siteQuestions: [],
}

const questionSlice = createSlice({
  name: 'question',
  initialState,
  reducers: {
    removeQuestions: (state) => {
      state.questions = initialState.questions
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(
        findAllQuestions.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.questions = payload
        },
      )
      .addCase(
        findSiteQuestions.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.siteQuestions = payload
        },
      )
      .addCase(
        createQuestion.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.questions = [...state.questions, payload]
        },
      )
      .addCase(
        updateQuestion.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          const index = state.questions.findIndex(
            (question) => question.id === payload.id,
          )
          if (index !== -1) {
            state.questions[index] = payload
          }
        },
      )
      .addCase(
        deleteQuestions.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.questions = state.questions.filter(
            (question) => !payload.includes(question.id),
          )
        },
      )
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        state.questions = state.questions.filter((q) => q.id !== action.payload)
      })
      .addCase(
        bulkDeleteQuestions.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.questions = state.questions.filter(
            (q) => !payload.includes(q.id),
          )
        },
      ),
})

export const { removeQuestions } = questionSlice.actions

export default questionSlice.reducer
